<template>
  <div class="tw-flex tw-flex-row tw-min-h-screen">
    <div class="tw-flex-1 tw-p-6">
      <div class="LoginMap tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full tw-rounded-3xl">
        <div class="tw-flex tw-items-center tw-absolute tw-top-[60px] tw-left-[60px]">
          <div class="tw-w-[60px] tw-h-[60px]">
            <icon-logo-square />
          </div>
          <h1 class="tw-leading-9 tw-ml-4">
            <span
              class="tw-text-primary"
            >i</span>Track
          </h1>
        </div>
        <div
          class="tw-flex tw-flex-col tw-p-10 tw-pb-8 tw-rounded-3xl tw-bg-white tw-max-w-[488px] tw-overflow-hidden tw-shadow"
        >
          <h1 class="tw-tracking-wider tw-mb-8">
            {{ $t('adm.reset_password.expired.title') }}
          </h1>
          <div class="tw-mb-10 tw-tracking-normal">
            {{ $t('adm.reset_password.autorefresh.text') }}
          </div>

          <div class="tw-w-[548px] tw-h-px tw-ml-[-40px] tw-bg-gray tw-mb-3" />

          <div class="tw-flex tw-justify-between">
            <router-link to="/login">
              <i-button
                type="transparent"
                size="large"
                class="tw-px-0 tw-text-primary"
              >
                <icon-angle-left />
                {{ $t('common.actions.navigate_to_login') }}
              </i-button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetLinkAutorefresh',
};
</script>
